import React, { useState } from 'react'
import { useOperatorContext } from './OperatorContextProvider';
import { loginUrl } from '../../providers/EnvContextProvider';
import { useTokensContext } from '../../providers/TokensContextProvider';
import './Login.css';
import ForgotPassword from './ForgotPassword';

export default function Login() {  
  const [credz, setCredz] = useState({});
  const {username, password} = credz;  
  const [loginState, setLoginState] = useState({code:0, msg:''});
  const {setOperator} = useOperatorContext();
  const {setIdToken, setAccessToken} = useTokensContext();
  const [forgotPassMode, setForgotPassMode] = useState(false);

  const { // Reducer
          dispatchOperatorFlag,          
          OperatorFlag,
        } = useOperatorContext();

  // ---[  handleChange  ]---
  //
  const handleChange = (e) => {
    setLoginState({code:0, msg:''});
    setCredz(prev => ({...prev, [e.target.name]: e.target.value}));
  } 


  // ---[   login   ]---
  // 
  // Todo: Refactor LOGIN: I did wrong here. 
  //        It should be event handling structured: fetch().then().then()...catch() so only affecting states async and no return should be considered.
  // 
  const login = async (credz) => {
    setLoginState({code:1, msg:'Signing in...'});
    
    //     Fetch /login
    //
    const response = await fetch(loginUrl, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'auth-u': credz.username,
        'auth-p': credz.password
      }
    }).catch(error => {
      console.log('Login Error: ' + error);
      setLoginState({code: 999, msg: "Hey! Were's the server?"});
      dispatchOperatorFlag(OperatorFlag.Eject);
    });

    //    Parse Response
    //
    if (response?.ok) {      
      //  Response Headers:
      const idToken = response.headers.get('auth-id-token');
      const accessToken = response.headers.get('authorization');      

      const tokens = {
        'idToken': idToken,
        'accessToken': accessToken,
        'hasWsCookie': 'true'
      };
      
      //  Response Body:
      const user = await response.json();
      tokens.user = user;
      
      if (tokens.accessToken) {
        setLoginState({code:response.status, msg:'Ok'});
      }
      else {
        setLoginState({code:'400', msg:'Sorry, No Access.'})                
      }
      
      return tokens;
    }
    else if (!response) { //    Error Handling
      console.error('Unable to get the login response object.');
      setLoginState({code: 998, msg: 'Sorry, No response from the server'});      
    }
    else {
      console.error('Error Detected.  Status: '+response.status + '.  Text: ' + response.statusText);

      if (response.status === 401 || response.status === 403) {
        setLoginState({code:response.status, msg:'Invalid username or password. '})
      }
      else if (response.status === 500) {
        setLoginState({code:response.status, msg: 'Server Error... '});
      }
      else if (response.status === 502) {
        setLoginState({code:response.status, msg: 'Server is down.'})
      }
      else {
        setLoginState({code:response.status, msg: 'Oops... Sorry!. Error Code: '+response.status+'. '});
      }          
    }
  }


  //
  // ---[   Submit  LOGIN   ]---
  //
  const handleSubmit = async (e) => {
    e.preventDefault();

    const tokens = await login({username, password});    

    if (tokens?.accessToken) {
      const user = tokens.user;
      if (!user) {
        console.error('User not exist in the login response! (but we got accessToken!)');
      }
      
      setOperator(user);
      setIdToken(tokens.idToken);
      setAccessToken(tokens.accessToken);            
      dispatchOperatorFlag(OperatorFlag.Ready);
      
      // Navigation to auth-required pages is too early at this point as we don't "see" the tokens yet in other components.  
      //    (it should be done using effect on tokens, on some public or higher level component)
    }
  }

  const handleForgotPassword = () => {
    console.log('[Login handleForgotPassword]');
    setForgotPassMode(true);    
  }

  const handleBackToLogin = () => {
    setForgotPassMode(false);
  }
  // ---  Render  ---

  return (
    <div className='loginWrap'>
      {!forgotPassMode && 
      <div className='loginBox'>
        <h2>Sign In</h2>

        <div className='loginBoxLabels'>
          <div className='formLabels'>
            <div>Username</div>
            <div>Password</div>
          </div>          

          <div className='loginBoxForm'>
            <form className='formInputs'>
              <input name='username' autoComplete='username' className='form-control input-lg' style={{width: 364}} onChange={handleChange} tabIndex={1} />
              <input type='password' name='password' autoComplete='current-password' className='form-control input-lg' style={{width: 364}} onChange={handleChange} tabIndex={2}/> 
              <div style={{display:'flex', justifyContent:'space-between', alignItems: 'baseline', marginTop: 8}}> 
                <div className='forgotPasswordQ' title="We'll email you a reset code" tabIndex={3} onClick={handleForgotPassword}>
                  Forgot Password?
                </div>
                <button className='btn btn-primary' onClick={handleSubmit} style={{width: 200}} tabIndex={4}> Sign in</button> 
              </div>
            </form>
            <div className='loginMsgBox' style={{color: loginState.code === 200 ? 'green' : 'red'}}>
                  {loginState.msg}
            </div>
          </div>
        </div>
      </div>}

      {forgotPassMode && <ForgotPassword email={username} backToLogin={handleBackToLogin}/>}
    </div>
  )
}
